"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioGroup = function (_Component) {
  _inherits(RadioGroup, _Component);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var name = Math.random().toString();
      var _props$options = this.props.options,
          enumOptions = _props$options.enumOptions,
          inline = _props$options.inline;


      {
        enumOptions.map(function (option, i) {
          var checked = option.value === _this2.props.value;
          var disabledCls = _this2.props.disabled || _this2.props.readonly ? "disabled" : "";
          var radio = _react2.default.createElement(_semanticUiReact.Checkbox, {
            radio: true,
            checked: checked,
            name: name,
            required: _this2.props.required,
            value: option.value,
            disabled: _this2.props.disabled || _this2.props.readonly,
            autoFocus: _this2.props.autofocus && i === 0,
            onChange: function onChange(_) {
              return _this2.props.onChange(option.value);
            },
            label: option.label
          });

          if (inline) {
            return _react2.default.createElement(
              "label",
              { key: i, className: "radio-inline " + disabledCls },
              radio
            );
          }
          return _react2.default.createElement(
            "div",
            { key: i, className: "radio " + disabledCls },
            _react2.default.createElement(
              "label",
              null,
              radio
            )
          );
        });
      }

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        enumOptions.map(function (option, i) {
          var checked = option.value === _this2.props.value;
          var disabledCls = _this2.props.disabled || _this2.props.readonly ? "disabled" : "";
          var radio = _react2.default.createElement(
            "span",
            null,
            _react2.default.createElement(_semanticUiReact.Checkbox, {
              type: "radio",
              checked: checked,
              name: name,
              required: _this2.props.required,
              value: option.value,
              disabled: _this2.props.disabled || _this2.props.readonly,
              autoFocus: _this2.props.autofocus && i === 0,
              onChange: function onChange(_) {
                return _this2.props.onChange(option.value);
              },
              label: option.label
            })
          );

          return inline ? _react2.default.createElement(
            "label",
            {
              key: i,
              className: "radio-inline " + disabledCls,
              style: { margin: "0 6px" } },
            radio
          ) : _react2.default.createElement(
            "div",
            { key: i, className: "radio " + disabledCls },
            _react2.default.createElement(
              "label",
              null,
              radio
            )
          );
        })
      );
    }
  }]);

  return RadioGroup;
}(_react.Component);

function RadioWidget(props) {
  return _react2.default.createElement(
    "div",
    { style: { display: "inline-block" } },
    _react2.default.createElement(RadioGroup, props)
  );
}

RadioWidget.defaultProps = {
  autofocus: false
};

if (process.env.NODE_ENV !== "production") {
  RadioWidget.propTypes = {
    schema: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.string.isRequired,
    options: _propTypes2.default.shape({
      enumOptions: _propTypes2.default.array,
      inline: _propTypes2.default.bool
    }).isRequired,
    value: _propTypes2.default.any,
    required: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    readonly: _propTypes2.default.bool,
    autofocus: _propTypes2.default.bool,
    onChange: _propTypes2.default.func
  };
}
exports.default = RadioWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsonschema-form-semanticui/lib/components/widgets/RadioWidget.js
// module id = 2150
// module chunks = 0